import { render, staticRenderFns } from "./mobileContentBox.vue?vue&type=template&id=09ea8611&"
import script from "./mobileContentBox.vue?vue&type=script&lang=js&"
export * from "./mobileContentBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports